import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_comp_form_small = _resolveComponent("comp-form-small")!
  const _component_comp_model = _resolveComponent("comp-model")!

  return (_openBlock(), _createBlock(_component_comp_model, {
    ref: "form_model",
    title: _ctx.title,
    height: "auto",
    onOnClose: _ctx.onClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_comp_form_small, {
        ref: "form",
        structure: _ctx.formStructure,
        submitApi: _ctx.formSubmitApi,
        onOnSubmit: _ctx.onSubmit
      }, null, 8, ["structure", "submitApi", "onOnSubmit"])
    ]),
    _: 1
  }, 8, ["title", "onOnClose"]))
}